import { render, staticRenderFns } from "./ModalProjectCosts.vue?vue&type=template&id=97bf9624"
import script from "./ModalProjectCosts.vue?vue&type=script&lang=js"
export * from "./ModalProjectCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports